// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'
import liftNodes from 'utils/GraphQL/typedLiftNodes'
import NotificationBadge from 'components/SideBar/ui/NotificationBadge'
import type {
  ProposalsNotifications_viewer as Viewer,
} from './__generated__/ProposalsNotifications_viewer.graphql'

type Props = $ReadOnly<{
  viewer: Viewer,
}>

function ProposalsNotifications({viewer}: Props): Node {
  const proposals = liftNodes(viewer.proposalsForResponse)

  return proposals.length > 0 && (
    <NotificationBadge count={proposals.length} />
  )
}

export default (createFragmentContainer(ProposalsNotifications, {
  viewer: graphql`
    fragment ProposalsNotifications_viewer on Person {
      proposalsForResponse: proposals(reviewStatus: TO_REVIEW) {
        edges {
          node {
            __typename
          }
        }
      }
    }
  `,
}): RelayFragmentContainer<typeof(ProposalsNotifications)>)
